<template>
  <div>
    <sweet-modal style="z-index: 9002 !important" class="sweet-modal-v-tabs" :title="$t('ct-option-link')"
                 v-on:close="onClose" ref="modalLink" :key="key_tab_change">

      <!--  ForEach para cada tipo de link  -->
      <template v-for="(typeLink, index) in typesLink">
        <!--  Sweet Tab -->
        <keep-alive>
          <sweet-modal-tab :title="$t(`ct-${typeLink.title}`)" :id="typeLink.type" :ref="typeLink.type" :key="index"
                           :disabled="!typeLink.active">
            <!--  Component modal body  -->
            <component v-bind:is="`action-${typeLink.type}`"
                       :selectedType="selectedType"
                       :element="element"
                       :website_id="website_id"
                       :pages="pages"
                       :popups="popups"
                       :anchors="anchors"
                       :target="target"
                       :ref="`component-${typeLink.type}`"
                       @enableLinkAction="enableLinkAction"
                       @disabledLinkAction="disabledLinkAction"
            ></component>
          </sweet-modal-tab>
        </keep-alive>
      </template>
      <div v-show="['web', 'page', 'restrictIntegration', 'newAnchor', 'votes'].includes(selectedType) && tabs !== 'mboss' && show.openInNewTab">
      <label class="w-100 my-2">{{ $t('ct-target') }}</label>
        <div class="form-check form-check-inline w-100">
          <input
            class="form-check-input"
            name="target_option"
            type="radio"
            v-model="target"
            id="radio-open-in-same-page"
            value="_self"
          />
          <label
            class="form-check-label"
            for="radio-open-in-same-page"
          >{{ $t('ct-open-in-same-page') }}</label>
        </div>
        <div class="form-check form-check-inline w-100">
          <input
            class="form-check-input"
            name="target_option"
            type="radio"
            v-model="target"
            id="radio-open-in-another-page"
            value="_blank"
          />
          <label
            class="form-check-label"
            for="radio-open-in-another-page"
          >{{ $t('ct-open-in-another-page') }}</label>
        </div>
        <div class="form-check form-check-inline w-100">
          <input
            class="form-check-input"
            name="target_option"
            type="radio"
            v-model="target"
            id="radio-open-in-parent"
            value="_parent"
          />
          <label
            class="form-check-label"
            for="radio-open-in-parent"
          >{{ $t('ct-open-in-parent') }}</label>
        </div>
        <!--  Secondary link config  -->
        <secondary-link
          v-if="target && target === '_blank'"
          :secondaryLink="secondaryLink" :selectedType="selectedType"
          :hasTagsAdvanced="hasTagsAdvanced" :pages="pages" @setProp="setProp"
        ></secondary-link>
      </div>
      <div v-if="this.selectedType !== 'tags' && this.selectedType !== 'builderall' && element && element.name && element.name !== 'MailingBossFormComponent'">
        <div class="form-check form-check-inline w-100">
          <input
            class="form-check-input"
            name="target_option"
            type="checkbox"
            v-model="pixel.active"
            id="radio-open-in-parent-2"
            value="_parent"
          />
          <label
            class="form-check-label"
            for="radio-open-in-parent-2"
          >{{ $t('ct-pixel-event-before') }}</label>
        </div>
        <div v-if="pixel.active" class="row" style="margin-top: 20px">
          <div class="form-group col-12">
            <span>{{ $t('ct-platforms') }}</span>
            <div class="form-check form-check-inline w-100">
              <input
                class="form-check-input"
                name="target_option"
                id="target_option"
                type="checkbox"
                v-model="pixel.facebook"
                value="_parent"
              />
              <label
                class="form-check-label"
                for="target_option"
              > Facebook </label>
            </div>
          </div>
          <div class="form-group col-8">
            <label>{{ $t('ct-pixel-standard-event') }}</label>
            <select class="form-control" v-model="pixel.standard_event" :disabled="standardEvent">
              <option value="" :selected="standardEvent">{{ $t('ct-select') }}</option>
              <option
                v-for="event,index in standardEvents"
                :key="index"
                :value="event.value"
              >{{ event.text  }}
              </option>
            </select>
          </div>
          <div v-if="pixel.standard_event == 'Purchase'" class="form-group col-8">
            <div class="row">
              <div class="form-group col-6">
                <label for="">{{ `${$t('ct-currency')} *` }}</label>
                <select class="form-control" v-model="pixel.purchase_event_info.currency" :class="{ 'is-invalid': errors.has('purchase_event_info.currency')}" @change="errors.clear('purchase_event_info.currency')">
                  <option value="">{{ $t('ct-select') }}</option>
                  <option
                    v-for="(currency,index) in currencies"
                    :key="index"
                    :value="currency.code"
                  >{{ currency.code  }}
                  </option>
                </select>
                <span v-if="errors.has('purchase_event_info.currency')" class="invalid-feedback" v-text="errors.get('purchase_event_info.currency')"></span>
              </div>
              <div class="form-group col-6">
                <label>{{ `${$t('ct-value')} *` }}</label>
                <input type="number" class="form-control" required="required" :class="{ 'is-invalid': errors.has('purchase_event_info.value')}"  @keyup="errors.clear('purchase_event_info.value')" @change="errors.clear('purchase_event_info.value')"  v-model="pixel.purchase_event_info.value">
                <span v-if="errors.has('purchase_event_info.value')" class="invalid-feedback" v-text="errors.get('purchase_event_info.value')"></span>
              </div>
              <!-- <div class="form-group col-6">
                <label >{{ $t('ct-currency') }}</label>
                <input type="text" class="form-control" :class="{ 'is-invalid': errors.has('purchase_event_info.currency')}" @keyup="errors.clear('purchase_event_info.currency')" required v-model="pixel.purchase_event_info.currency">
                <span v-if="errors.has('purchase_event_info.currency')" class="invalid-feedback" v-text="errors.get('purchase_event_info.currency')"></span>
              </div>   -->
            </div>
          </div>
          <div class="form-group col-8">
            <label for="pixel-event">{{ $t('ct-pixel-custom-event') }}</label>
            <input type="text" class="form-control" id="pixel-event" v-model="pixel.value">
          </div>
        </div>
        <div class="form-check form-check-inline w-100">
          <input
            class="form-check-input"
            name="target_option"
            type="checkbox"
            v-model="vote.active"
            id="inlineCheckboxVoteUnique"
            value="_parent"
          />
          <label
            class="form-check-label"
            for="inlineCheckboxVoteUnique"
          >{{ $t('ct-vote-event-before') }}</label>
        </div>
        <div v-if="vote.active" class="row" style="margin-top: 20px">
          <div class="form-group col-8">
            <label>{{ $t('ct-question') }}</label>
            <select v-model="vote.question" @change="changeOptions" name="" id="" class="form-control">
              <option :value="0">{{ $t('select') }} </option>
              <option v-for="question in voteQuestions" :key="question.id" :value="question.code">{{ question.description }} </option>
            </select>
            <div class="form-check form-check-inline w-100 mt-1">
              <input
                class="form-check-input"
                name="only_once"
                type="checkbox"
                v-model.number="vote.only_once"
                id="only-once"
                :value="1"
              />
              <label
                class="form-check-label"
                for="only-once"
              >{{ $t('ct-vote-unique') }}</label>
            </div>
          </div>
          <div class="col-4">
              <button @click="getVoteActions" style="margin-top: 30px" class="btn btn-secondary">{{ $t('ct-update') }}</button>
          </div>
          <div class="form-group col-8">
            <label>{{ $t('ct-answer') }}</label>
            <select v-model="vote.option" name="" id="" class="form-control">
              <option :value="0">{{ $t('select') }} </option>
              <option v-for="question in voteOptions" :key="question.id" :value="question.option">{{ question.description }} </option>
            </select>
          </div>
          <div class="form-group col-8" v-if="vote.only_once">
            <label for="vote-url">{{ $t('ct-vote-url') }}</label>
            <input type="text" class="form-control" id="vote-url" v-model="vote.url" required="required">
            <small class="text-gray">{{ $t('ct-vote-help') }}</small>
          </div>
        </div>
      </div>
      <button slot="button" v-on:click="$refs.deleteConfirm.open()" class="btn btn-danger ml-0" style="float: left">
        {{ $t('ct-reset-action') }}
      </button>
      <button
        slot="button"
        class="btn btn-primary float-left"
        @click.prevent="$refs.createPopup.open()"
        v-if="selectedType === 'popup'"
      >{{ $t('ct-create-new-popup') }}
      </button>
      <button slot="button" class="btn btn-default" v-on:click="cancel">
        {{ $t('ct-cancel') }}
      </button>
      <button slot="button" class="btn btn-success" v-on:click="save"><i
        class="svg-icon svgi-save"></i>{{ $t('ct-select') }}
      </button>
    </sweet-modal>
    <create-pop-up-component :layout_id="layout_id" :page_id="page_id" :popups="popups" ref="createPopup"
                             style="z-index: 9020" @updatePopups="updatePopups"></create-pop-up-component>

    <sweet-modal ref="deleteConfirm" :title="$t('ct-confirm')" width="500px" style="z-index: 9020">
      <button slot="button" class="btn btn-default" v-on:click="$refs.deleteConfirm.close()">
        {{ $t('ct-cancel') }}
      </button>
      <button slot="button" class="btn btn-danger" v-on:click="clean">{{ $t('ct-delete') }}</button>
    </sweet-modal>
  </div>
</template>
<script>
import {getWebsiteLink} from '../../../../js/services/editor/link';
import ModalFiles from '../../../general/FilesManager/FileManager';
import CreatePopUpComponent from '../CreatePopUp';
import {SweetModal, SweetModalTab} from "sweet-modal-vue";
import Errors from '../../../../js/base/Errors';
import {get as getQuestions} from "../../../../js/services/editor/votesystem";
import currencies from "@/assets/currencies.json";

const typeLinks = [
  {type: 'web', title: 'link-web', active: true},
  {type: 'page', title: 'link-page', active: true},
  {type: 'builderall', title: 'action-link-builderall', active: true},
  {type: 'popup', title: 'link-popup', active: true},
  {type: 'newAnchor', title: 'link-anchor', active: true},
  {type: 'video', title: 'link-video', active: true},
  {type: 'download', title: 'link-download', active: true},
  {type: 'supercheckout', title: 'link-supercheckout', active: true},
  {type: 'email', title: 'email', active: true},
  {type: 'telefone', title: 'link-phone', active: true},
  {type: 'restrict', title: 'members-area', active: false},
  {type: 'restrictIntegration', title: 'link-restrict-integration', active: false},
  {type: 'tags', title: 'link-tags', active: true},
  {type: 'slider', title: 'link-slider', active: true},
  {type: 'browserNotification', title: 'link-browser-n', active: false},
  {type: 'showHidePanel', title: 'show-hide-panel', active: true},
  // {type: 'powerUp', title: 'link-power-up', active: true},
  {type: 'multiple', title: 'link-multiple', active: true},
  {type: 'copy', title: 'link-copy', active: true}
];

export default {
  name: 'LinkComponent',
  props: ['website_id', 'layout_id', 'page_id'],
  components: {
    SweetModal,
    SweetModalTab,
    ModalFiles,
    CreatePopUpComponent,
    'action-web': () => import('./actions/ActionWeb'),
    'action-page': () => import('./actions/ActionPage'),
    'action-builderall': () => import('./actions/ActionBuilderall'),
    'action-popup': () => import('./actions/ActionPopup'),
    'action-newAnchor': () => import('./actions/ActionNewAnchor'),
    'action-download': () => import('./actions/ActionDownload'),
    'action-video': () => import('./actions/ActionVideo'),
    'action-supercheckout': () => import('./actions/ActionSupercheckout'),
    'action-email': () => import('./actions/ActionEmail'),
    'action-telefone': () => import('./actions/ActionTelefone'),
    'action-restrict': () => import('./actions/ActionRestrict'),
    'action-restrictIntegration': () => import('./actions/ActionRestrictIntegration'),
    'action-tags': () => import('./actions/ActionTags'),
    'action-slider': () => import('./actions/ActionSlider'),
    'action-browserNotification': () => import('./actions/ActionBrowserNotification'),
    'action-showHidePanel': () => import('./actions/ActionShowHidePanel'),
    'action-multiple': () => import('./actions/ActionMultiple'),
    'action-copy': () => import('./actions/ActionCopy'),
    'secondary-link': () => import('./SecondaryLink'),
  },
  data() {
    return {
      currencies: currencies,
      errors: new Errors(),
      element: null,
      el_editor: null,
      callback: null,
      onClose: () => {
      },
      tabs: 'all',
      selectedType: 'web',
      value: 'https://',
      key_tab_change: 1,
      target: '_blank',
      typeLinkSelected: 'web',
      typesLink: [
        {type: 'web', title: 'link-web', active: true},
        {type: 'page', title: 'link-page', active: true},
        {type: 'builderall', title: 'action-link-builderall', active: true},
        {type: 'popup', title: 'link-popup', active: true},
        {type: 'newAnchor', title: 'link-anchor', active: true},
        {type: 'video', title: 'link-video', active: true},
        {type: 'download', title: 'link-download', active: true},
        {type: 'supercheckout', title: 'link-supercheckout', active: true},
        {type: 'email', title: 'email', active: true},
        {type: 'telefone', title: 'link-phone', active: true},
        {type: 'restrict', title: 'members-area', active: false},
        {type: 'restrictIntegration', title: 'link-restrict-integration', active: false},
        {type: 'tags', title: 'link-tags', active: true},
        {type: 'slider', title: 'link-slider', active: true},
        {type: 'browserNotification', title: 'link-browser-n', active: false},
        {type: 'showHidePanel', title: 'show-hide-panel', active: true},
        // {type: 'powerUp', title: 'link-power-up', active: true},
        {type: 'multiple', title: 'link-multiple', active: true},
        {type: 'copy', title: 'link-copy', active: true}
      ],
      tagsAdvanced: false,
      hasTagsAdvanced: false,
      show: {
        openInNewTab: true,
      },
      secondaryLink: {
        'type': 'page',
        'value': '', // if value type is web
        'valueID': '0' // if valueID type is page
      },
      pixel: {
        active: false,
        facebook: false,
        gtm: false,
        value: '',
        standard_event: '',
        purchase_event_info: {
          value: 0, 
          currency: ''
        }
      },
      vote: {
        active: false,
        question: 0,
        option: 0,
        only_once: false,
        url: '',
      },
      voteQuestions: [],
      voteOptions: [],
      anchors: [],
      popups: [],
      pages: [],
      disabled: {
        type: Boolean,
        default: false
      },
      standardEvents: [
        {text: 'Add payment info', value: 'AddPaymentInfo'},
        {text: 'Add to cart', value: 'AddToCart'},
        {text: 'Add to wishlist', value: 'AddToWishlist'},
        {text: 'Complete registration', value: 'CompleteRegistration'},
        {text: 'Contact', value: 'Contact'},
        {text: 'Customize product', value: 'CustomizeProduct'},
        {text: 'Donate', value: 'Donate'},
        {text: 'Find location', value: 'FindLocation'},
        {text: 'Initiate checkout', value: 'InitiateCheckout'},
        {text: 'Lead', value: 'Lead'},
        {text: 'Purchase', value: 'Purchase'},
        {text: 'Schedule', value: 'Schedule'},
        {text: 'Search', value: 'Search'},
        {text: 'Start trial', value: 'StartTrial'},
        {text: 'Submit application', value: 'SubmitApplication'},
        {text: 'Subscribe', value: 'Subscribe'},
        {text: 'View content', value: 'ViewContent'}
      ],
      standardEvent: false
    };
  },

  watch: {
    'pixel.value': {
      handler: function (val) {
        if (val !== '') {
          this.standardEvent = true;
          this.pixel.standard_event = '';
        } else {
          this.standardEvent = false;
        }
      },
      deep: true
    },
    pixel: {
      handler: function (val) {
        if (!val.purchase_event_info) {
          this.pixel.purchase_event_info = {value: 0, currency: ''};
        }
      },
      deep: true
    },
  },

  methods: {
    forceUpdateTabs() {
      var vm = this;
      vm.key_tab_change += 1;
    },

    disabledLinkAction(type) {

      this.typesLink.forEach((link, i) => {
        if (link.type === type) {
          this.typesLink[i].active = false;
        }
      });
    },

    enableLinkAction(type) {
      if ((this.el_editor && !(['button', 'image', 'menu'].includes(this.el_editor.name))) || !this.el_editor) {
        return;
      }

      this.typesLink.forEach((link, i) => {
        if (link.type === type) {
          this.typesLink[i].active = true;
        }
      });
    },

    setProp(key, value) {
      this[key] = value;
    },

    getCurrentTab() {
      return (this.$refs.modalLink) ? this.$refs.modalLink.current_tab.id : 'web';
    },

    selectType(val) {
      this.selectedType = (val === 'anchor') ? 'newAnchor' : val;

      if (this.selectedType === 'multiple') {
        this.show.openInNewTab = false;
        this.target = '_self';
      } else {
        this.show.openInNewTab = true;
      }
    },

    setTargets() {
      let vm = this;
      let selected = vm.selectedType || 'web';

      $(this.$refs.modalLink.$el).on('click', function () {
        selected = vm.$refs.modalLink.current_tab.id;
        vm.selectType(selected);
      });
    },

    clean() {
      let obj = {
        type: 'web',
        value: '',
        tel: '',
        valueID: '',
        target: '_blank',
        telSelectedMask: '',
        telOpenAs: '',
        pixel: {
        active: false,
        facebook: false,
        gtm: false,
        value: '',
        standard_event: '',
        purchase_event_info: {
          value: 0, 
          currency: ''
        }
      },
        vote : {
          active: false,
          question: 0,
          option: 0,
        },
        tagsAdvanced: false,
        secondaryLink: {
          'type': 'page',
          'value': '', // if value type is web
          'valueID': '0' // if valueID type is page
        },
      };

      if (this.callback != null) {
        this.callback(obj);
      } else {
        this.element.internal_config['link'] = obj;
      }

      this.$refs.deleteConfirm.close();
      this.cancel();
    },

    save() {
      if(this.pixel.standard_event == 'Purchase') {
        this.pixel.purchase_event_info.value = parseInt(this.pixel.purchase_event_info.value);
        const { value, currency } = this.pixel.purchase_event_info;

        if(currency == '') {
          this.errors.add( 'currency', 'is-required', 'purchase_event_info');
          return;
        }  else if(isNaN(value) || value < 0) {
          this.errors.add( 'value', 'is-required', 'purchase_event_info');
          return;
        } 
      }
      

      this.selectedType = this.getCurrentTab();
      this.selectedType = (this.selectedType === 'anchor') ? 'newAnchor' : this.selectedType;

      var componentName = `component-${this.getCurrentTab()}`;
      var componentAction = this.$refs[componentName][0];
      var actionValue = componentAction.getValue();
      var actionValueProps = componentAction.getPropsConfig();

      if (actionValue === false) {
        return;
      }

      if (this.selectedType === 'tags') {
        this.selectedType = 'web'
      }

      if (this.selectedType === 'anchor') {
        this.selectedType = 'newAnchor'
      }

      let obj = {
        type: this.selectedType,
        target: this.target,
        secondaryLink: this.secondaryLink,
        pixel: this.pixel,
        vote: this.vote,
        ...actionValueProps,
        value: actionValue
      };

      if (this.callback != null) {
        this.callback(obj);
      } else {
        this.element.internal_config['link'] = obj;
      }

      this.cancel();
    },

    cancel() {
      var vm = this;
      this.typesLink.forEach(link => {
          try {
            var componentName = `component-${link.type}`;
            var componentAction = vm.$refs[componentName][0];
            componentAction.clean();
          }catch (e) {
            console.error(e);
          }
      });

      this.$refs.modalLink.close();
    },

    loadData(el, data = null, callback = null, tabs = 'all', onClose = () => {}) {
      let vm = this;
      let $link;

      vm.tabs = tabs;
      vm.anchors = [];
      vm.popups = [];
      vm.pages = [];
      vm.element = el;
      vm.callback = callback;
      vm.onClose = onClose;

      if(vm.element !== null && typeof vm.element.internal_config !== 'undefined' && typeof vm.element.internal_config.link !== 'undefined') {
        data = vm.element.internal_config.link
      }

      if (tabs === 'mboss' && this.typesLink.length > 2) {

        var typesLink = typeLinks.filter(link => ['page', 'web'].includes(link.type));

        this.typesLink = [];
        this.typesLink = typesLink;

        this.forceUpdateTabs();

      } else if (tabs === 'all') {

        this.typesLink = [];
        this.typesLink = typeLinks;

        // Desativa menus da area de membros se for diferente de menu e botão
        if ((el && !(['button', 'image', 'menu'].includes(el.name))) || !el) {
          this.typesLink.forEach(link => {
            if(['restrict', 'restrictIntegration'].includes(link.type)){
              link.active = false;
            }
          });
        }

        if ((el && !(['button'].includes(el.name))) || !el) {
          this.typesLink.forEach(link => {
            if(['copy'].includes(link.type)){
              link.active = false;
            }
          });
        }

        if (el && el.internal_config && el.internal_config.name === 'timer') {
          vm.show.openInNewTab = false;
          vm.target = '_self';
          console.log('is timer');
        } else {
          vm.show.openInNewTab = true;
        }

        this.el_editor = el;
        this.forceUpdateTabs();
      }

      if (data != null) {
        $link = data;
      } else {
        // set default value if empty
        if (typeof vm.element.internal_config.link === 'undefined') {
          vm.element.internal_config['link'] = {
            type: 'web',
            value: '',
            valueID: '',
            target: '_blank',
            tel: '',
            telSelectedMask: '',
            telOpenAs: '',
            pixel: {
              active: false,
              facebook: false,
              gtm: false,
              value: '',
              standard_event: '',
              purchase_event_info: {
                value: 0, 
                currency: ''
              }
            },
            vote : {
              active: false,
              question: 0,
              option: 0,
            }
          };
        }

        $link = vm.element.internal_config.link;
      }

      vm.selectedType = $link.type || 'web';
      vm.target = $link.target || '_blank';
      vm.value = $link.value;

      if (vm.selectedType === 'anchor') {
        vm.selectedType = 'newAnchor'
      }

      if (typeof $link.secondarylink !== 'undefined' && typeof $link.secondarylink === 'string') {
        vm.secondaryLink = JSON.parse($link.secondarylink);
      } else
        vm.secondaryLink = $link.secondaryLink || vm.secondaryLink;

      if (typeof $link.pixel !== 'undefined') {
        this.pixel = $link.pixel;
      } else {
        this.pixel = {
          active: false,
          facebook: false,
          gtm: false,
          value: '',
          standard_event: '',
          purchase_event_info: {
            value: 0, 
            currency: ''
          }
        }
      }

      if (typeof $link.vote !== 'undefined') {
        this.vote = $link.vote;
        this.getVoteOptions()
      } else {
        this.vote = {
          active: false,
          question: 0,
          option: 0,
        }
      }

      this.$loading.show();
      getWebsiteLink(this.website_id)
        .then(res => {

          if (res.data && res.data.config) {
            // Ativa Broswe Notification
            res.data.config.forEach(config => {
              if (config.key === 'browserSettings' && config.value) {
                let browserSettings = JSON.parse(config.value);

                if (typeof browserSettings.open_site_load !== 'undefined' && !browserSettings.open_site_load) {
                  this.enableLinkAction('browserNotification');
                }
              }
            });
          }

          res.data.layouts.forEach(layout => {
            layout.pages.forEach(page => {
              vm.pages.push({
                page_id: page.id,
                page_name: page.name
              });

              if (typeof page.config !== 'undefined' && page.config != null) {
                try {
                  page.config.forEach(config => {
                    if (config.key === 'anchors') {
                      let anchors = JSON.parse(config.value);
                      Object.keys(anchors).forEach(idAnchor => {
                        if (anchors[idAnchor] != '') {
                          vm.anchors.push({
                            page_id: page.id,
                            page_name: page.name,
                            anchor_id: idAnchor,
                            anchor_name: anchors[idAnchor]
                          });
                        }
                      });
                    }
                  });
                } catch (e) {
                  console.log(e, page);
                }
              }
            });
            layout.popups.forEach(popup => {
              vm.popups.push({
                popup_id: popup.id,
                popup_name: popup.name
              });
            });
          });

        })
        .finally(() => {
          this.$loading.hide();

          var componentName = `component-${vm.selectedType}`;
          var componentAction = this.$refs[componentName][0];

          //set value depois de escolhido
          componentAction.setPropsConfig($link, this.element);
          componentAction.setValue($link.value);
          vm.setTargets();

          vm.$refs.modalLink.open(vm.selectedType);
        });
    },

    updatePopups(popups) {
      this.popups = [];

      popups.forEach(popup => {
        this.popups.push({
          popup_id: popup.id,
          popup_name: popup.name
        });
      });
    },

    getVoteActions() {
      getQuestions(this.website_id)
        .then( response => {
          this.voteQuestions = response.data.data
        } )
    },

    getVoteOptions() {
      this.voteQuestions.forEach( question => {
        if(question.code === this.vote.question) {
          this.voteOptions = question.options
        }
      } )
    },

    changeOptions() {
      this.vote.option = 0;
      this.voteQuestions.forEach( question => {
        if(question.code === this.vote.question) {
          this.voteOptions = question.options
        }
      } )
    }
  },
  mounted() {

    let vm = this;

    setTimeout( function() {
      vm.getVoteActions();
    }, 2000 )

  }
};
</script>

<style lang="scss" scoped>
.sweet-modal .sweet-content .form-group .form-control {
  border-radius: 3px;
  height: 47px;
  font-family: Lato;
  color: #656565;

  
}
.container-accordion-form {
  .card .card-header {
    font-size: 18px;
    padding: 1rem 1.25rem;
    border-bottom: none !important;
    cursor: pointer;

    .collapsed svg {
      -webkit-transform: rotateZ(90deg);
      transform: rotateZ(90deg);
    }

    svg.fa-sort-down, svg.fa-chevron-down {
      float: right;
      font-size: 15px;
      margin: 5px 0;
      -webkit-transition: all 0.4s ease;
      transition: all 0.4s ease;
      color: #0294ff;
    }
  }

  span {
    font-family: "Muli", "Lato", "Helvetica Neue", Helvetica, Arial, sans-serif;
  }
}
</style>
<style lang="scss">
.sweet-modal {
  max-width: 990px !important;
}

.modal-backdrop {
  background-color: rgba(37, 37, 37, 0.9);
}

.modal-content {
  background-color: #f3f7ff !important;
  box-shadow: 0 14px 32px rgba(0, 0, 0, .25098039215686274) !important;
  border-radius: 10px !important;
}

.modal-title {
  font-weight: 700 !important;
  font-size: 20px !important;
  font-family: Muli;
  color: #434343;

  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

/** TAGS */
.nav-tags a {
  text-decoration: none;
  cursor: pointer;

  &.active {
    font-weight: bold;
  }
}

.content-tags {
  max-height: 400px;
}

.sweet-modal-v-tabs {
  .sweet-modal {
    .sweet-content {
      max-height: none !important;
    }

    .sweet-content-content {
      max-height: 70vh !important;
      overflow: hidden auto;
      padding: 0 2px;
    }
  }
}

.modal-link-config-container {
  display: flex;
  align-items: flex-start;

  .list-group {
    width: 200px;
  }

  .modal-link-config-body {
    margin-left: 15px;
    width: calc(100% - 215px) !important;
    background-color: #fff;
    border: 1px solid #e3e8eb !important;
    border-radius: 4px;

    padding: 10px;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/editor/base/link/Link.vue